import { Routes, Route } from 'react-router-dom';
import LocationMenu from './pages/LocationMenu';
import SingleMenu from './pages/SingleMenu';

const App = () => {
  return (
    <Routes>
      <Route path="/location/:locationId" element={<LocationMenu />} />
      <Route path="/:id" element={<SingleMenu />} />
    </Routes>
  );
};

export default App;